import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = ["innerHTML"]

import SubSection from '../common/SubSection.vue';
import { useUIContent } from '@/guiide/ts/configuration/useUIContent';


export default /*@__PURE__*/_defineComponent({
  __name: 'RiskWarnings',
  setup(__props) {

const { htmlArray } = useUIContent();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SubSection, {
        title: "Risk warnings",
        showHelp: false
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(htmlArray)('disclaimers.risk-warnings'), (warning, i) => {
            return (_openBlock(), _createElementBlock("p", {
              key: i,
              innerHTML: warning
            }, null, 8, _hoisted_3))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})